import s from "../../../common-lib/utils/window.js";
import { isIOS as t, isAndroid as i } from "@walletconnect/utils";
const e = () => t() || i(), A = () => {
  if (s()) {
    const r = navigator.userAgent;
    return /OKApp/i.test(r);
  }
  return !1;
};
export {
  e as isIosOrAndroid,
  A as isOkxApp
};
//# sourceMappingURL=index.js.map
